// Cross-component "open this playlist" channel for PlaylistSidebar.
//
// `lastExpandedPlaylistId` is the sidebar's mount-restore memory (returning to
// the Library page lands back on the playlist you left open). Kept here, not
// in the component, so callers OUTSIDE the sidebar — e.g. the "was added to
// <playlist>" toast link — can pre-set it: on mobile the page mounts on
// setActiveTab('playlists') and opens straight onto it. For an already-mounted
// desktop sidebar the event below triggers the expand.
let lastExpandedPlaylistId = null;
export const getLastExpandedPlaylistId = () => lastExpandedPlaylistId;
export const setLastExpandedPlaylistId = (id) => { lastExpandedPlaylistId = id; };

export const OPEN_PLAYLIST_EVENT = 'mg:open-playlist';

// Show a playlist (or, with null, the playlist LIST) without adding a history
// entry: used by Back/Forward and by the sidebar's Playlists item, which
// always lands on the list. The listener reads `push: false`.
export function requestShowPlaylist(playlistId) {
    lastExpandedPlaylistId = playlistId == null ? null : playlistId;
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(OPEN_PLAYLIST_EVENT, { detail: { playlistId: playlistId == null ? null : playlistId, push: false } }));
    }
}
export function requestOpenPlaylist(playlistId) {
    if (playlistId == null) return;
    lastExpandedPlaylistId = playlistId;
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(OPEN_PLAYLIST_EVENT, { detail: { playlistId } }));
    }
}

// "New playlist" from outside the Playlists page (the phone Library hub's +):
// the page that mounts next opens its create dialog. A flag, not an event, so
// only the page being opened takes it — a sidebar already mounted elsewhere
// never sees it.
let pendingCreate = false;
export function requestCreatePlaylist() { pendingCreate = true; }
export function takePendingCreatePlaylist() { const p = pendingCreate; pendingCreate = false; return p; }
